// import { Box } from "./Box.js";
const steps = [
  {
    label: "Order Confirmed",
    map: {
      center: {
        lat: 39.968209,
        lng: -75.140624,
      },
      zoom: 15.5,
      heading: 360,
      tilt: 0,
    },
  },
  {
    label: "Received",
    map: {
      center: {
        lat: 39.960932,
        lng: -75.143212,
      },
      zoom: 18,
      heading: 340,
      tilt: 47.5,
    },
  },
  {
    label: "Packing",
    map: {
      center: {
        lat: 39.960932,
        lng: -75.143212,
      },
      zoom: 19.5,
      heading: 363,
      tilt: 65,
    },
  },
  {
    label: "Driver Picking Up",
    map: {
      center: {
        lat: 39.960932,
        lng: -75.143212,
      },
      zoom: 21,
      heading: 400,
      tilt: 65,
    },
  },
  {
    label: "On the way!",
    map: {
      center: {
        lat: 39.963179,
        lng: -75.142844,
      },
      zoom: 17,
      heading: 340,
      tilt: 20,
    },
  },
];

const warehouse = [
  { lat: 39.961013, lng: -75.14321 },
  { lat: 39.96097, lng: -75.14287 },
  { lat: 39.961123, lng: -75.142858 },
  { lat: 39.961155, lng: -75.143175 },
];

const state = {
  map: null,
  currentStep: 0,
  origin: { lat: 39.960932, lng: -75.143212 },
  destination: { lat: 39.97419, lng: -75.137498 },
};

export const buildMap = () => {
  const map = new google.maps.Map(document.getElementById("map"), {
    ...steps[state.currentStep].map,
    mapId: "5e6ed676eaebf907",
    disableDefaultUI: true,
  });
  state.map = map;

  drawRoute(map);

  const markerOrigin = new google.maps.Marker({
    position: state.origin,
    icon: "mfc_pin.png",
    map: map,
  });
  const markerDestination = new google.maps.Marker({
    position: state.destination,
    icon: "home_pin.png",
    map: map,
  });
  // drawWarehouse();
  drawWarehouse3D();
};

const drawRoute = (map) => {
  var directionsService = new google.maps.DirectionsService();
  var directionsDisplay = new google.maps.DirectionsRenderer({
    map: map,
    ...steps[0].map,
    suppressMarkers: true,
    polylineOptions: { strokeColor: "#00A4FF" },
  });

  var origin = new google.maps.LatLng(state.origin.lat, state.origin.lng);
  var destination = new google.maps.LatLng(
    state.destination.lat,
    state.destination.lng
  );
  var request = {
    origin: origin,
    destination: destination,
    travelMode: google.maps.TravelMode.DRIVING,
  };

  directionsService.route(request, function (result, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsDisplay.setDirections(result);
    }
    setTimeout(() => map.setOptions(steps[0].map), 500);
  });
};

const drawWarehouse = () => {
  const pg = new google.maps.Polygon({
    paths: warehouse,
    strokeColor: "#00A4FF",
    strokeOpacity: 0.8,
    strokeWeight: 3,
    fillColor: "#00A4FF",
    fillOpacity: 0.35,
  });
  pg.setMap(state.map);
};

const drawWarehouse3D = () => {
  const webGLOverlayView = new google.maps.WebGLOverlayView();
  let scene, renderer, camera, loader;
  webGLOverlayView.onAdd = () => {
    console.log("onAdd");
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera();
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.75); // soft white light
    scene.add(ambientLight);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.25);
    directionalLight.position.set(0.5, -1, 0.5);
    scene.add(directionalLight);

    loader = new THREE.GLTFLoader();
    loader.load("Sketchfab_Scene.gltf", (gltf) => {
      gltf.scene.scale.set(5, 5, 5);
      gltf.scene.rotation.x = (90 * Math.PI) / 180;
      gltf.scene.rotation.y = (90 * Math.PI) / 180;
      scene.add(gltf.scene);
    });
  };

  webGLOverlayView.onContextRestored = ({ gl }) => {
    renderer = new THREE.WebGLRenderer({
      canvas: gl.canvas,
      context: gl,
      ...gl.getContextAttributes(),
    });
    renderer.autoClear = false;
  };
  webGLOverlayView.onDraw = ({ gl, transformer }) => {
    const latLngAltitudeLiteral = {
      lat: 39.961057,
      lng: -75.143147,
      altitude: 0,
    };

    const matrix = transformer.fromLatLngAltitude(latLngAltitudeLiteral);
    camera.projectionMatrix = new THREE.Matrix4().fromArray(matrix);

    webGLOverlayView.requestRedraw();
    renderer.render(scene, camera);
    renderer.resetState();
  };
  webGLOverlayView.setMap(state.map);
};

// Control Step
const fwd = document.getElementById("forward");
const back = document.getElementById("back");
const label = document.getElementById("label");
const duration = 3000;
const numSteps = 90;
let step = 0;
let stepSize = false;
let start = {};
var curTilt;
var curCenter;
var curHeading;
var curZoom;
const transitionSteps = (a, b) => {
  if (!stepSize) {
    curTilt = state.map.getTilt();
    curCenter = state.map.getCenter();
    curHeading = state.map.getHeading() || a.heading;
    curZoom = state.map.getZoom();
    start.lat = curCenter.lat();
    start.lng = curCenter.lng();
    stepSize = {
      lat: (b.center.lat - curCenter.lat()) / numSteps,
      lng: (b.center.lng - curCenter.lng()) / numSteps,
      zoom: (b.zoom - curZoom) / numSteps,
      heading: (b.heading - a.heading) / numSteps,
      tilt: (b.tilt - curTilt) / numSteps,
    };
  }
  var newPosition = {
    lat: start.lat + stepSize.lat * step,
    lng: start.lng + stepSize.lng * step,
  };
  var newZoom = curZoom + stepSize.zoom * step;
  var newTilt = curTilt + stepSize.tilt * step;
  var newHeading = curHeading + stepSize.heading * step;
  // console.log("map.newPosition()", newPosition, newZoom, newTilt, newHeading);
  state.map.panTo(newPosition);
  state.map.setZoom(newZoom);
  state.map.setTilt(newTilt);
  state.map.setHeading(newHeading);

  if (step < numSteps) {
    step++;
    setTimeout(() => transitionSteps(a, b), duration / numSteps);
  } else {
    step = 0;
    stepSize = false;
    console.log("transition done");
  }
};

const updateStep = (d) => {
  transitionSteps(
    steps[state.currentStep].map,
    steps[state.currentStep + d].map
  );
  state.currentStep += d;
  label.textContent = steps[state.currentStep].label;
  console.log("current step:", state.currentStep);
};
fwd.addEventListener("click", () => updateStep(1));
back.addEventListener("click", () => updateStep(-1));
